import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HelpText = styled.p`
  color: var(--color-accent-secondary-default);
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 24px;
  margin-top: 16px;
`;

const Title = styled(Typography)`
  align-items: center;
  color: var(--color-accent-secondary-default);
  display: flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 700;
  line-height: 100%;
`;

const CardHeader = styled.div`
  align-items: center;
  display: flex;
`;

const CardHeaderDescription = styled.div``;

const SharePublicLinkLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--size-16);
`;

const SharePublicLink = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  gap: 8px;
`;

export { CardHeader, CardHeaderDescription, HelpText, SharePublicLink, SharePublicLinkLeft, Title };
